import { i18n } from '@fs/zion-locale'

export default {
  copySuccess: () =>
    i18n.t('infoSheetWrapper.copyImageLinkToClipboardSuccess', 'Image group number copied to clipboard.'),
  copyError: () =>
    i18n.t(
      'infoSheetWrapper.copyImageLinkToClipboardError',
      'There was an error copying the image group number to the clipboard.'
    ),
  invalidCoverage: () =>
    i18n.t('groupData.invalidCoverage', 'A place, record type, and date are required to complete the audit.'),
  backToAudit: () => i18n.t('metadata-audit.back-to-audit-list-button', 'Back to Audit List'),
  goToImageGroup: () => i18n.t('metadata-audit.searchImageLink.tooltip', 'Go to Image Group'),
  metadataAudit: () => i18n.t('metadata-audit.heading', 'Metadata Audit'),
  qualityStandardsButton: () => i18n.t('metadata-audit.metadata-quality-standards.link', 'Metadata Quality Standards'),
  imageGroupDetails: () => i18n.t('infoSheetWrapper.searchImageLink.tooltip', 'Image Group Details'),
  imageGroupNumber: () => i18n.t('metadata-audit.imageGroupNumber', 'Image Group Number'),
  copyImageGroupNumber: () => i18n.t('infoSheetWrapper.copyImageLinkToClipboard.tooltip', 'Copy Image Group Number'),
  edit: () => i18n.t('GroupDataHeader.editButtonText', 'Edit'),
  submitAudit: () => i18n.t('groupData.submitAuditButtonText', 'Submit Audit'),
}
